<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1longevitylane1">CHAPTER 1 - LONGEVITY LANE(1)</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2longevitylane2">CHAPTER 2 - LONGEVITY LANE(2)</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter3sneaker1">CHAPTER 3 - SNEAKER(1)</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter4sneaker2">CHAPTER 4 - SNEAKER(2)</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter5homicide1">CHAPTER 5 - HOMICIDE(1)</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter6homicide2">CHAPTER 6 - HOMICIDE(2)</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter7endangered1">CHAPTER 7 - ENDANGERED(1)</a>
</li>
<li class="table-of-content">
<span href="#/7_chapter8endangered2" title="Link target outside of Sample">CHAPTER 8 - ENDANGERED(2)</span>
</li>
<li class="table-of-content">
<span href="#/8_chapter9bloodfighting1" title="Link target outside of Sample">CHAPTER 9 - BLOOD-FIGHTING(1)</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter10bloodfighting2" title="Link target outside of Sample">CHAPTER 10 - BLOOD-FIGHTING(2)</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter11initialdisplayskill1" title="Link target outside of Sample">CHAPTER 11 - INITIAL DISPLAY SKILL(1)</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter12initialdisplayskill2" title="Link target outside of Sample">CHAPTER 12 - INITIAL DISPLAY SKILL(2)</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter13encounteranoldfriend1" title="Link target outside of Sample">CHAPTER 13 - ENCOUNTER AN OLD FRIEND(1)</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter14encounteranoldfriend2" title="Link target outside of Sample">CHAPTER 14 - ENCOUNTER AN OLD FRIEND(2)</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter15netherkarmicfire1" title="Link target outside of Sample">CHAPTER 15 - NETHER KARMIC FIRE(1)</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter16netherkarmicfire2" title="Link target outside of Sample">CHAPTER 16 - NETHER KARMIC FIRE(2)</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter17graveprotectingbeastspirit1" title="Link target outside of Sample">CHAPTER 17 - GRAVE-PROTECTING BEAST SPIRIT(1)</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter18graveprotectingbeastspirit2" title="Link target outside of Sample">CHAPTER 18 - GRAVE-PROTECTING BEAST SPIRIT(2)</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter19spiritualdeficiencyofthedaotomb1" title="Link target outside of Sample">CHAPTER 19 - SPIRITUAL DEFICIENCY OF THE DAO TOMB(1)</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter20spiritualdeficiencyofthedaotomb2" title="Link target outside of Sample">CHAPTER 20 - SPIRITUAL DEFICIENCY OF THE DAO TOMB(2)</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter21atthebattleofthevoid1" title="Link target outside of Sample">CHAPTER 21 - AT THE BATTLE OF THE VOID(1)</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter22atthebattleofthevoid2" title="Link target outside of Sample">CHAPTER 22 - AT THE BATTLE OF THE VOID(2)</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter23abattleofspiritsanddeficiency1" title="Link target outside of Sample">CHAPTER 23 - A BATTLE OF SPIRITS AND DEFICIENCY(1)</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter24abattleofspiritsanddeficiency2" title="Link target outside of Sample">CHAPTER 24 - A BATTLE OF SPIRITS AND DEFICIENCY(2)</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter25thedaughterofagraverobber1" title="Link target outside of Sample">CHAPTER 25 - THE DAUGHTER OF A GRAVE ROBBER(1)</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter26thedaughterofagraverobber2" title="Link target outside of Sample">CHAPTER 26 - THE DAUGHTER OF A GRAVE ROBBER(2)</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter27anxietybuilding1" title="Link target outside of Sample">CHAPTER 27 - ANXIETY BUILDING(1)</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter28anxietybuilding2" title="Link target outside of Sample">CHAPTER 28 - ANXIETY BUILDING(2)</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter29midnightrose1" title="Link target outside of Sample">CHAPTER 29 - MIDNIGHT ROSE(1)</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter30midnightrose2" title="Link target outside of Sample">CHAPTER 30 - MIDNIGHT ROSE(2)</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter31goldenhosttalentshow1" title="Link target outside of Sample">CHAPTER 31 - GOLDEN HOST TALENT SHOW(1)</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter32goldenhosttalentshow2" title="Link target outside of Sample">CHAPTER 32 - GOLDEN HOST TALENT SHOW(2)</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter33suresidence1" title="Link target outside of Sample">CHAPTER 33 - SU RESIDENCE(1)</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter34suresidence2" title="Link target outside of Sample">CHAPTER 34 - SU RESIDENCE(2)</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter35ghostwife1" title="Link target outside of Sample">CHAPTER 35 - GHOST WIFE(1)</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter36ghostwife2" title="Link target outside of Sample">CHAPTER 36 - GHOST WIFE(2)</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter37thebattleofthesuresidence1" title="Link target outside of Sample">CHAPTER 37 - THE BATTLE OF THE SU RESIDENCE(1)</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter38thebattleofthesuresidence2" title="Link target outside of Sample">CHAPTER 38 - THE BATTLE OF THE SU RESIDENCE(2)</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter39awakeningofsoul1" title="Link target outside of Sample">CHAPTER 39 - AWAKENING OF SOUL(1)</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter40awakeningofsoul2" title="Link target outside of Sample">CHAPTER 40 - AWAKENING OF SOUL(2)</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter41iceandsnowparadise1" title="Link target outside of Sample">CHAPTER 41 - ICE AND SNOW PARADISE(1)</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter42iceandsnowparadise2" title="Link target outside of Sample">CHAPTER 42 - ICE AND SNOW PARADISE(2)</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter43nightdemonasura1" title="Link target outside of Sample">CHAPTER 43 - NIGHT DEMON ASURA(1)</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter44nightdemonasura2" title="Link target outside of Sample">CHAPTER 44 - NIGHT DEMON ASURA(2)</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter45abeastfighting1" title="Link target outside of Sample">CHAPTER 45 - A BEAST FIGHTING(1)</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter46abeastfighting2" title="Link target outside of Sample">CHAPTER 46 - A BEAST FIGHTING(2)</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter47meilansnowparti1" title="Link target outside of Sample">CHAPTER 47 - MEILAN SNOW PART I(1)</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter48meilansnowparti2" title="Link target outside of Sample">CHAPTER 48 - MEILAN SNOW PART I(2)</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter49meilansnowpartii1" title="Link target outside of Sample">CHAPTER 49 - MEILAN SNOW PART II(1)</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter50meilansnowpartii2" title="Link target outside of Sample">CHAPTER 50 - MEILAN SNOW PART II(2)</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter51meilansnowpartii1" title="Link target outside of Sample">CHAPTER 51 - MEILAN SNOW PART II(1)</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter52meilansnowpartii2" title="Link target outside of Sample">CHAPTER 52 - MEILAN SNOW PART II(2)</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter53polygonumcuspidatumthunb1" title="Link target outside of Sample">CHAPTER 53 - POLYGONUM CUSPIDATUM THUNB(1)</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter54polygonumcuspidatumthunb2" title="Link target outside of Sample">CHAPTER 54 - POLYGONUM CUSPIDATUM THUNB(2)</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter55thecataclysm1" title="Link target outside of Sample">CHAPTER 55 - THE CATACLYSM(1)</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter56thecataclysm2" title="Link target outside of Sample">CHAPTER 56 - THE CATACLYSM(2)</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter57threealliances1" title="Link target outside of Sample">CHAPTER 57 - THREE ALLIANCES(1)</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter58threealliances2" title="Link target outside of Sample">CHAPTER 58 - THREE ALLIANCES(2)</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter59insightfuldeficiency1" title="Link target outside of Sample">CHAPTER 59 - INSIGHTFUL DEFICIENCY(1)</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter60insightfuldeficiency2" title="Link target outside of Sample">CHAPTER 60 - INSIGHTFUL DEFICIENCY(2)</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter61netherpalaces1" title="Link target outside of Sample">CHAPTER 61 - NETHER PALACES(1)</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter62netherpalaces2" title="Link target outside of Sample">CHAPTER 62 - NETHER PALACES(2)</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter63afflictioni1" title="Link target outside of Sample">CHAPTER 63 - AFFLICTION I(1)</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter64afflictioni2" title="Link target outside of Sample">CHAPTER 64 - AFFLICTION I(2)</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter65afflictionpartii1" title="Link target outside of Sample">CHAPTER 65 - AFFLICTION PART II(1)</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter66afflictionpartii2" title="Link target outside of Sample">CHAPTER 66 - AFFLICTION PART II(2)</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter67afflictioniii1" title="Link target outside of Sample">CHAPTER 67 - AFFLICTION III(1)</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter68afflictioniii2" title="Link target outside of Sample">CHAPTER 68 - AFFLICTION III(2)</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter69vileaffections41" title="Link target outside of Sample">CHAPTER 69 - VILE AFFECTIONS 4(1)</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter70vileaffections42" title="Link target outside of Sample">CHAPTER 70 - VILE AFFECTIONS 4(2)</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter71affliction51" title="Link target outside of Sample">CHAPTER 71 - AFFLICTION 5(1)</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter72affliction52" title="Link target outside of Sample">CHAPTER 72 - AFFLICTION 5(2)</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter73affliction61" title="Link target outside of Sample">CHAPTER 73 - AFFLICTION 6(1)</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter74affliction62" title="Link target outside of Sample">CHAPTER 74 - AFFLICTION 6(2)</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter75affliction71" title="Link target outside of Sample">CHAPTER 75 - AFFLICTION 7(1)</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter76affliction72" title="Link target outside of Sample">CHAPTER 76 - AFFLICTION 7(2)</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter77affliction81" title="Link target outside of Sample">CHAPTER 77 - AFFLICTION 8(1)</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter78affliction82" title="Link target outside of Sample">CHAPTER 78 - AFFLICTION 8(2)</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter79inheritanceoftheicelady1" title="Link target outside of Sample">CHAPTER 79 - INHERITANCE OF THE ICE LADY(1)</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter80inheritanceoftheicelady2" title="Link target outside of Sample">CHAPTER 80 - INHERITANCE OF THE ICE LADY(2)</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter81jinyuan1" title="Link target outside of Sample">CHAPTER 81 - JIN YUAN(1)</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter82jinyuan2" title="Link target outside of Sample">CHAPTER 82 - JIN YUAN(2)</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter83thebattleofjinyuan11" title="Link target outside of Sample">CHAPTER 83 - THE BATTLE OF JINYUAN 1(1)</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter84thebattleofjinyuan12" title="Link target outside of Sample">CHAPTER 84 - THE BATTLE OF JINYUAN 1(2)</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter85thebattleofjinyuanpartii1" title="Link target outside of Sample">CHAPTER 85 - THE BATTLE OF JINYUAN PART II(1)</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter86thebattleofjinyuanpartii2" title="Link target outside of Sample">CHAPTER 86 - THE BATTLE OF JINYUAN PART II(2)</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter87sandalwoodspiritbook1" title="Link target outside of Sample">CHAPTER 87 - SANDALWOOD SPIRIT BOOK(1)</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter88sandalwoodspiritbook2" title="Link target outside of Sample">CHAPTER 88 - SANDALWOOD SPIRIT BOOK(2)</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter89namelessfield1" title="Link target outside of Sample">CHAPTER 89 - NAMELESS FIELD(1)</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter90namelessfield2" title="Link target outside of Sample">CHAPTER 90 - NAMELESS FIELD(2)</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter91enternamelessdomain1" title="Link target outside of Sample">CHAPTER 91 - ENTER NAMELESS DOMAIN(1)</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter92enternamelessdomain2" title="Link target outside of Sample">CHAPTER 92 - ENTER NAMELESS DOMAIN(2)</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter93bloodcoloredflock1" title="Link target outside of Sample">CHAPTER 93 - BLOOD-COLORED FLOCK(1)</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter94bloodcoloredflock2" title="Link target outside of Sample">CHAPTER 94 - BLOOD-COLORED FLOCK(2)</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter95whiterockprisoner1" title="Link target outside of Sample">CHAPTER 95 - WHITE ROCK PRISONER(1)</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter96whiterockprisoner2" title="Link target outside of Sample">CHAPTER 96 - WHITE ROCK PRISONER(2)</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter97primarysubspace1" title="Link target outside of Sample">CHAPTER 97 - PRIMARY SUBSPACE(1)</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter98primarysubspace2" title="Link target outside of Sample">CHAPTER 98 - PRIMARY SUBSPACE(2)</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter99advice1" title="Link target outside of Sample">CHAPTER 99 - ADVICE(1)</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter100advice2" title="Link target outside of Sample">CHAPTER 100 - ADVICE(2)</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2368c91e